(function () {
  'use strict';

  function initGaleria() {
    var principal = document.querySelector('[data-mt-imagen-principal]');
    var miniaturas = document.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full) principal.setAttribute('src', full);
        miniaturas.forEach(function (b) {
          b.style.outline = 'none';
        });
        btn.style.outline = '2px solid var(--mt-color-texto)';
        btn.style.outlineOffset = '2px';
      });
    });
  }

  function initVariantes() {
    var form = document.querySelector('[data-mt-form-producto]');
    if (!form) return;

    var script = form.querySelector('[data-mt-variantes]');
    var input = form.querySelector('[data-mt-variant-id]');
    var boton = form.querySelector('[data-mt-boton-comprar]');
    var textoBoton = form.querySelector('[data-mt-texto-boton]');
    var botonTarjeta = document.querySelector('[data-mt-boton-tarjeta]');
    var textoBotonTarjeta = document.querySelector('[data-mt-texto-boton-tarjeta]');
    var grupos = form.querySelectorAll('[data-mt-opcion]');
    if (!script || !input || !grupos.length) return;

    var variantes = JSON.parse(script.textContent);
    var seleccion = {};

    grupos.forEach(function (grupo) {
      var activo = grupo.querySelector('[style*="background: var(--mt-color-texto)"]') || grupo.querySelector('button');
      if (activo) seleccion[grupo.dataset.mtOpcion] = activo.dataset.mtValor;

      grupo.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mt-valor]');
        if (!btn) return;
        seleccion[grupo.dataset.mtOpcion] = btn.dataset.mtValor;

        grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) {
          b.style.background = '';
          b.style.color = '';
        });
        btn.style.background = 'var(--mt-color-texto)';
        btn.style.color = 'var(--mt-color-fondo)';

        actualizarVariante();
      });
    });

    function actualizarVariante() {
      var match = variantes.find(function (v) {
        return Object.keys(seleccion).every(function (pos) {
          return v['option' + pos] === seleccion[pos];
        });
      });
      if (!match) return;

      input.value = match.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (match.available) {
        boton.removeAttribute('disabled');
        if (textoBoton) textoBoton.textContent = boton.dataset.mtTextoDisponible || textoBoton.textContent;
        if (botonTarjeta) botonTarjeta.removeAttribute('disabled');
      } else {
        boton.setAttribute('disabled', 'disabled');
        if (textoBoton && boton.dataset.mtTextoAgotado) textoBoton.textContent = boton.dataset.mtTextoAgotado;
        if (botonTarjeta) botonTarjeta.setAttribute('disabled', 'disabled');
      }
    }
  }

  function initCantidad() {
    var form = document.querySelector('[data-mt-form-producto]');
    if (!form) return;

    var input = form.querySelector('[data-mt-cantidad-input]');
    var menos = form.querySelector('[data-mt-cantidad-menos]');
    var mas = form.querySelector('[data-mt-cantidad-mas]');
    var variantIdInput = form.querySelector('[data-mt-variant-id]');
    var script = form.querySelector('[data-mt-variantes]');
    if (!input || !menos || !mas) return;

    var variantes = [];
    try {
      variantes = script ? JSON.parse(script.textContent) : [];
    } catch (e) {
      variantes = [];
    }

    function limiteInventario() {
      if (!variantIdInput) return Infinity;
      var actual = variantes.find(function (v) {
        return String(v.id) === String(variantIdInput.value);
      });
      if (!actual) return Infinity;
      // Solo limitamos si Shopify controla el inventario y la política no permite sobreventa.
      if (actual.inventory_management === 'shopify' && actual.inventory_policy !== 'continue') {
        return Math.max(actual.inventory_quantity, 0);
      }
      return Infinity;
    }

    function fijarCantidad(valor) {
      var limite = limiteInventario();
      var n = parseInt(valor, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (limite !== Infinity) {
        if (limite < 1) n = 1; // sin stock: los botones ya están deshabilitados aparte
        else if (n > limite) n = limite;
      }
      input.value = n;
      // Avisamos a cualquier otro script (p. ej. apps de terceros) de que el valor cambió.
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    menos.addEventListener('click', function () {
      fijarCantidad((parseInt(input.value, 10) || 1) - 1);
    });
    mas.addEventListener('click', function () {
      fijarCantidad((parseInt(input.value, 10) || 1) + 1);
    });
    input.addEventListener('input', function () {
      input.value = input.value.replace(/[^0-9]/g, '');
    });
    input.addEventListener('change', function () {
      fijarCantidad(input.value);
    });

    // Si cambia la variante seleccionada, revalidamos la cantidad contra su stock.
    if (variantIdInput) {
      variantIdInput.addEventListener('change', function () {
        fijarCantidad(input.value);
      });
    }
  }

  function initBotonTarjeta() {
    var boton = document.querySelector('[data-mt-boton-tarjeta]');
    var form = document.querySelector('[data-mt-form-producto]');
    if (!boton || !form) return;
    var input = form.querySelector('[data-mt-variant-id]');
    var cantidadInput = form.querySelector('[data-mt-cantidad-input]');
    var texto = document.querySelector('[data-mt-texto-boton-tarjeta]');
    var textoOriginal = texto ? texto.textContent : '';

    boton.addEventListener('click', function () {
      if (boton.disabled || !input || !input.value) return;

      var cantidad = parseInt((cantidadInput && cantidadInput.value) || '1', 10);
      if (isNaN(cantidad) || cantidad < 1) cantidad = 1;

      boton.disabled = true;
      if (texto) texto.textContent = 'Procesando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: input.value, quantity: cantidad }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'error'); });
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          boton.disabled = false;
          if (texto) texto.textContent = textoOriginal;
          alert('No se pudo procesar el pago. Inténtalo de nuevo.');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGaleria();
    initVariantes();
    initCantidad();
    initBotonTarjeta();
  });
})();
